import Cookies from "vue-cookie";

export const StoreState = {
  id: 'id'
};

export default {
  id: Cookies.get(StoreState.id)
};
